import React, { useState } from "react";
import { PageHeaderSection, ArticleSection, CustomOffcanvas, StyledButton, CustomInput } from "../components";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import bg_03 from "./../images/Content/Backhaus-Häussler-34.jpg"
import bg_05 from "./../images/Content/haeussler-job-01.webp"
import { validateForm } from "../utils/validation";
import { sendContactRequest } from "../utils/api/apiNoAuth";

const mailTemplate = 
  `Eine neue B2B Anfrage von {{companyName}} ist eingegangen\n
  Kontaktperson: {{contactPerson}}
  E-Mail: {{contactPersonMail}}
  Telefon: {{contactPersonPhone}}
  Adresse: {{address}}
  PLZ, Ort: {{postalCode}}, {{city}}\n
  USt-ID: {{vatId}}
  Steuer-Nr.: {{taxNumber}}\n
  Interesse an Produkten: {{productsInterest}}
  Bestellhäufigkeit: {{orderFrequency}}
  `;

const B2B: React.FunctionComponent = () => {
  const { t } = useTranslation(["b2b", "commom"]);

  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    contactPersonMail: "",
    contactPersonPhone: "",
    address: "",
    postalCode: "",
    city: "",
    vatId: "",
    taxNumber: "",
    productsInterest: "",
    orderFrequency: "",
  });

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const validationResult = validateForm([
        { name: "companyName", value: formData.companyName, isRequired: true },
        { name: "contactPerson", value: formData.contactPerson, isRequired: true },
        { name: "contactPersonMail", value: formData.contactPersonMail, isRequired: true, isEmail: true },
        { name: "contactPersonPhone", value: formData.contactPersonPhone, isRequired: false },
        { name: "address", value: formData.address, isRequired: true },
        { name: "postalCode", value: formData.postalCode, isRequired: true },
        { name: "city", value: formData.city, isRequired: true },
        { name: "vatId", value: formData.vatId, isRequired: false },
        { name: "taxNumber", value: formData.taxNumber, isRequired: false },
        { name: "productsInterest", value: formData.productsInterest, isRequired: true },
        { name: "orderFrequency", value: formData.orderFrequency, isRequired: true },
      ])

      if (!validationResult.isValid) {
        console.log("Fehler:", validationResult.errors);
        alert("Bitte füllen Sie alle erforderlichen Felder korrekt aus.");
        return;
      }

      const message = mailTemplate
        .replace('{{companyName}}', formData.companyName)
        .replace('{{contactPerson}}', formData.contactPerson)
        .replace('{{contactPersonMail}}', formData.contactPersonMail)
        .replace('{{contactPersonPhone}}', formData.contactPersonPhone)
        .replace('{{address}}', formData.address)
        .replace('{{postalCode}}', formData.postalCode)
        .replace('{{city}}', formData.city)
        .replace('{{vatId}}', formData.vatId)
        .replace('{{taxNumber}}', formData.taxNumber)
        .replace('{{productsInterest}}', formData.productsInterest)
        .replace('{{orderFrequency}}', formData.orderFrequency);

      const data = {
        name: formData.companyName,
        email: formData.contactPersonMail,
        phone: formData.contactPersonPhone,
        subject: 'B2B Anfrage',
        message: message,
      };

      await sendContactRequest(data)
    } catch (error) {
      console.error('Fehler beim Senden:', error);
    }
  }

  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline={t("page_header.headline")}
        subheadline={t("page_header.subheadline")}
        content={<></>}
      />
      <ArticleSection
        layout="article_left"
        title={t("sections.language.title")}
        content={
          <div style={contentStyle}>{t("sections.language.content")}</div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
      <ArticleSection
        layout="article_right_bg"
        title={t("sections.optimization.title")}
        content={
          <div style={contentStyle}>{t("sections.optimization.content")}</div>
        }
        imageUrl={bg_03}
        backgroundColor="#F4EBE5"
      />
      <ArticleSection
        layout="article_left"
        title={t("sections.regional.title")}
        content={
          <div style={contentStyle}>{t("sections.regional.content")}</div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
      <PageHeaderSection
        headline={t("sections.closing.headline")}
        subheadline={t("sections.closing.subheadline")}
        style={{ marginBottom: 100, marginTop: 100 }}
        content={
          <div style={{ justifyContent: "center", display: "flex" }}>
            <StyledButton title={t("sections.closing.button")} onClick={() => setShowForm(true)} />
          </div>
        }
      />
      <CustomOffcanvas
        show={showForm}
        onHide={() => setShowForm(false)}
        title={t("b2bForm.title")}
        imageUrl={bg_05}
        children={
          <section style={{ marginBottom: "100px" }} id={"section_start"}>
            <Container>
              <Row>
                <h4 style={{ marginBottom: 25 }}>Firmen- und Ansprechpartnerdaten</h4>
                {/* Firmen- und Ansprechpartnerdaten */}
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="companyName"
                    label={t("b2bForm.fields.companyName")}
                    required
                    value={formData.companyName}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                    <CustomInput
                      name="contactPerson"
                      label={t("b2bForm.fields.contactPerson")}
                      required
                      value={formData.contactPerson}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomInput
                    name="contactPersonMail"
                    label={t("b2bForm.fields.contactPersonMail")}
                    required
                    value={formData.contactPersonMail}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomInput
                    name="contactPersonPhone"
                    label={t("b2bForm.fields.contactPersonPhone")}
                    value={formData.contactPersonPhone}
                    onChange={handleInputChange}
                  />
                </Col>
                <h4 style={{ marginBottom: 25 }}>Firmensitz & Lieferadresse</h4>
                {/* Firmensitz & Lieferadresse */}
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="address"
                    label={t("b2bForm.fields.address")}
                    required
                    value={formData.address}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                  <CustomInput
                    name="postalCode"
                    label={t("b2bForm.fields.postalCode")}
                    required
                    value={formData.postalCode}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={8} lg={8} md={8} sm={8} xs={8}>
                  <CustomInput
                    name="city"
                    label={t("b2bForm.fields.city")}
                    required
                    value={formData.city}
                    onChange={handleInputChange}
                  />
                </Col>
                <h4 style={{ marginBottom: 25 }}>Steuer- und Unternehmensinformationen</h4>
                {/* Steuer- und Unternehmensinformationen */}
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomInput
                    name="vatId"
                    label={t("b2bForm.fields.vatId")}
                    value={formData.vatId}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <CustomInput
                    name="taxNumber"
                    label={t("b2bForm.fields.taxNumber")}
                    value={formData.taxNumber}
                    onChange={handleInputChange}
                  />
                </Col>
                <h4 style={{ marginBottom: 25 }}>Einkaufsdetails & Bedürfnisse</h4>
                {/* Einkaufsdetails */}
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="productsInterest"
                    label={t("b2bForm.fields.productsInterest")}
                    type="textarea"
                    required
                    value={formData.productsInterest}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="orderFrequency"
                    label={t("b2bForm.fields.orderFrequency")}
                    required
                    value={formData.orderFrequency}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>
              <div style={{ justifyContent: "right", display: "flex" }}>
                <StyledButton title={t("b2bForm.button")} onClick={handleSubmit} isRevert/>
              </div>
            </Container>
          </section>
        }
      />
    </Container>
  );
}

export default B2B;
